import React, { useState } from "react";
import { Button, Modal, Form, Row, Col } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { RiShareBoxFill } from "react-icons/ri";
import { handleErrors } from "../../services/dataManager";
import LoadingSpinner from "../../Components/spinner";
import { getAdApiDetails } from "../../services/axios/apiManager";
import { format } from "date-fns";
const AdApiDetailsModal = ({ showDetailsModal, setShowDetailsModal, id }) => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [authorized, setAuthorized] = useState(false);
  const [passwordError, setPasswordError] = useState("");
  const [password, setPassword] = useState("");
  const [adApiDetails, setAdApiDetails] = useState(null);

  const checkPassword = () => {
    if (!password.trim()) {
      setPasswordError("Password is required.");
      return false;
    } else if (password.trim().length < 6) {
      setPasswordError("Password must be atleast 8 characters long.");
      return false;
    } else {
      setPasswordError("");
      return true;
    }
  };

  const fetchAdApiDetails = async () => {
    setLoading(true)
    const isPasswordOK = checkPassword();

    if (isPasswordOK) {
      const res = await getAdApiDetails({ id: id, password: password });
      if (res?.data?.success && res?.data?.data) {
        setAdApiDetails(res.data.data);
        setAuthorized(true);
      } else {
        handleErrors(res, navigate, "Ad API details:");
      }
    }
    setLoading(false)
  };

  const hideModal = () => {
    setPassword("");
    setPasswordError("");
    setAdApiDetails(null);
    setAuthorized(false);
    setLoading(false);
    setShowDetailsModal(false);
  };
  return (
    <Modal
      show={showDetailsModal}
      onHide={() => {
        hideModal();
      }}
      centered
      backdrop="static"
      className="text-light"
      size="lg"
    >
      <Modal.Header closeButton className="bg-dark text-light border-0">
        <Modal.Title className="text-light">Ad Api Details</Modal.Title>
      </Modal.Header>
      <Modal.Body className="bg-dark text-light">
        {authorized ? (
          <Row>
            <Col xs={12} md={12} lg={6} className="mb-3">
              <div
                className="p-3 bg-secondary bg-opacity-10 rounded"
                style={{ overflow: "auto" }}
              >
                <span className="text-secondary fs-6 fw-semibold">Name</span>
                <span className="d-block fs-5 fw-medium">
                  {adApiDetails?.name || ""}
                </span>
              </div>
            </Col>
            <Col xs={12} md={12} lg={6} className="mb-3">
              <div
                className="p-3 bg-secondary bg-opacity-10 rounded"
                style={{ overflow: "auto" }}
              >
                <span className="text-secondary fs-6 fw-semibold">
                  Total Ad Units
                </span>
                <Row>
                  <Col>
                    <span className="d-block fs-5 fw-medium">
                      {adApiDetails?.total_ad_units || 0}
                    </span>
                  </Col>
                  <Col className="d-flex justify-content-end">
                    <Button
                      variant="outline-success"
                      size="md"
                      onClick={() => {
                        navigate(`/AdsApi/Ad-Unit/${id}`);
                      }}
                      title="view ad-units"
                    >
                      <RiShareBoxFill />
                    </Button>
                  </Col>
                </Row>
              </div>
            </Col>
            {Object.entries({
              Email: adApiDetails?.credentials?.email || "",
              "User Name": adApiDetails?.credentials?.user_name || "",
              Password: adApiDetails?.credentials?.password || "",
              Token: adApiDetails?.credentials?.token || "",
              "Login Via Social Account": adApiDetails?.using_social
                ? "Yes"
                : "No",
              Status: adApiDetails.status === 1 ? "Active" : "Inactive",
              "Created At":
                (adApiDetails.createdAt &&
                  format(adApiDetails.createdAt, "PP")) ||
                "",
              "Updated At":
                (adApiDetails.updatedAt &&
                  format(adApiDetails.updatedAt, "PP")) ||
                "",
            }).map(([key, value]) => (
              <Col xs={12} md={12} lg={6} className="mb-3" key={key}>
                <div
                  className="p-3 bg-secondary bg-opacity-10 rounded"
                  style={{ overflow: "auto" }}
                >
                  <span className="text-secondary fs-6 fw-semibold">{key}</span>
                  <span
                    className={`d-block fs-5 fw-medium ${!value && "text-danger"}`}
                    data-testid={`detail-${key?.toLowerCase().replace(/\s+/g, "-")}`}
                  >
                    {value || "N/A"}
                  </span>
                </div>
              </Col>
            ))}
          </Row>
        ) : (
          <div>
            <Form.Group className="mb-3">
              <Form.Label>Enter Your Password</Form.Label>
              <Form.Control
                type="password"
                id="password"
                data-testid="password-input"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Enter Password"
                className="bg-dark text-light border-light"
              />
              {passwordError && (
                <span className="text-danger">{passwordError}</span>
              )}
            </Form.Group>

            <div className="container-fluid">
              <div className="d-flex justify-content-end align-items-center">
                {loading && (
                  <div
                    className="mt-3 me-2"
                    data-testid="loading-spinner"
                  >
                    <LoadingSpinner size="lg" />
                  </div>
                )}
                <Button
                  variant="success"
                  className="mt-3"
                  data-testid="submit-button"
                  onClick={fetchAdApiDetails}
                >
                  Submit
                </Button>
              </div>
            </div>
          </div>
        )}
      </Modal.Body>
    </Modal>
  );
};

export default AdApiDetailsModal;
